import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useWebsite } from '../../Data/Website';
import Form, { RequiredValidator, Actions, Wysiwyg, Assets, Switch, SwitchGroup, Conditional, TextField } from '../../Components/Form';
import Alert from '../../Components/Alert';
import Tabs, { Tab } from '../../Components/Containers/Tabs/Tabs';

const Content = () => {
    const {website, updateContent, updateWidgetOptions} = useWebsite(true);

    return <>
        <TopBar left="/more" title="Website content" />
        <Page>
            {website && <Inner {...{website, updateContent, updateWidgetOptions}} />}
        </Page>
    </>
}

const Inner = ({website, updateContent, updateWidgetOptions}) => {
    if (website.type !== 'getsoapy') {
        return <Alert theme="error" title="Not available" message="This feature is only available for getSoapy websites." />
    }

    return <Tabs>
        <Tab title="Content">
            <Form data={website} onSubmit={updateContent}>
                <Wysiwyg name="aboutText"
                    label="Homepage text"
                    features={['basicFormatting', 'moreFormatting', 'advancedFormatting']}
                    validators={[RequiredValidator]}
                />

                <Assets name="aboutAssets"
                    label="Homepage images"
                    tags={[{name: 'Website', value: 'About'}]}
                    dimensions={['500x']}
                    showPrevious
                />


                <SwitchGroup name="footerOptions"
                    label="Footer options"
                    switches={[
                        {name: 'showAddress', label: 'Show address'},
                        {name: 'showSocials', label: 'Show social media links'},
                        {name: 'showPhoneNumber', label: 'Show phone number'},
                        {name: 'showEmail', label: 'Show email address'},
                        {name: 'showPoweredBySoapy', label: 'Show "Powered By getSoapy"'},
                    ]}
                />

                <Actions submit={{label: 'Save'}} />
            </Form>
        </Tab>

        <Tab title="Widgets">
            <Form data={website.widgetOptions} onSubmit={updateWidgetOptions}>

                <Switch name="useV2"
                    label="Use improved widgets"
                    innerLabel="Use improved widgets"
                    help="Use the latest version of Quote, Payment, and Customer Portal widgets, which have improved features and design.
                        While we're rolling out these new version you can temporarily switch back in case of issues."
                />

                <Conditional condition={data => data.useV2}>
                    <Switch name="combinedWidget"
                        label="Combined widgets"
                        innerLabel="Combine the Quote, Pay and Portal widgets"
                    />
                    <Conditional condition={data => data.combinedWidget}>
                        <TextField name="combinedTitle"
                            label="Combined widget title"
                            placeholder="Customer Portal"
                            help="The title that will be shown above the combined widget"
                        />
                    </Conditional>
                </Conditional>

                <Actions submit={{label: 'Save'}} />
            </Form>
        </Tab>
    </Tabs>

}

export default Content;
